import { useMutation } from "@tanstack/react-query";
import { editChatMessage } from "controller/api";
import type { EditChatMessageInput } from "shared";

export const useEditChatMessage = () => {
  return useMutation(
    (value: EditChatMessageInput) => editChatMessage(value),
  );
};
